import type { FluxErrorEntityErrorCodes } from '../types.js';

export const MfaErrorCodes = {
  MfaDisableInvalidMfaCode: {
    code: 'mfa/disable-invalid-mfa-code',
    message: 'Código MFA inválido.',
    explanation: 'O código MFA fornecido para desativar a autenticação multifator é inválido.',
    localizations: {},
  },
  MfaDisableInvalidSession: {
    code: 'mfa/disable-invalid-session',
    message: 'Sessão MFA inválida.',
    explanation: 'A sessão MFA para desativar a autenticação multifator é inválida.',
    localizations: {},
  },
  MfaEnableInvalidMfaCode: {
    code: 'mfa/enable-invalid-mfa-code',
    message: 'Código MFA inválido.',
    explanation: 'O código MFA fornecido para ativar a autenticação multifator é inválido.',
    localizations: {},
  },
  MfaEnableInvalidSession: {
    code: 'mfa/enable-invalid-session',
    message: 'Sessão MFA inválida.',
    explanation: 'A sessão MFA para ativar a autenticação multifator é inválida.',
    localizations: {},
  },
  MfaInvalidMfaCode: {
    code: 'mfa/invalid-code',
    message: 'Código inválido.',
    explanation: 'O código MFA fornecido é inválido.',
    localizations: {},
  },
  MfaInvalidToken: {
    code: 'mfa/invalid-token',
    message: 'Token inválido.',
    explanation: 'O token MFA fornecido é inválido.',
    localizations: {},
  },
  MfaNotEnabled: {
    code: 'mfa/not-enabled',
    message: 'MFA não está habilitado.',
    explanation: 'A autenticação multifator não está habilitada para este usuário.',
    localizations: {},
  },
  MfaNotFound: {
    code: 'mfa/not-found',
    message: 'Autenticação multifator não encontrada.',
    explanation: 'A configuração de autenticação multifator para este usuário não foi encontrada.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'mfa'>;

export const PasswordResetErrorCodes = {
  PasswordResetNotFound: {
    code: 'password-reset/not-found',
    message: 'Solicitação de redefinição de senha não encontrada.',
    explanation:
      'A solicitação de redefinição de senha que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
  PasswordResetTokenAlreadyUsed: {
    code: 'password-reset/token-already-used',
    message: 'O token de redefinição de senha já foi utilizado.',
    explanation: 'O token de redefinição de senha que você está tentando usar já foi utilizado.',
    localizations: {},
  },
  PasswordResetTokenNotFound: {
    code: 'password-reset/token-not-found',
    message: 'Token de redefinição de senha não encontrado.',
    explanation: 'O token de redefinição de senha que você está tentando usar não foi encontrado.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'password-reset'>;

export const RecoveryCodesErrorCodes = {
  RecoveryCodeAlreadyUsed: {
    code: 'recovery-code/already-used',
    message: 'Código de recuperação já utilizado.',
    explanation: 'O código de recuperação que você está tentando usar já foi utilizado.',
    localizations: {},
  },
  RecoveryCodeInvalidRecoveryCode: {
    code: 'recovery-code/invalid',
    message: 'Código de recuperação inválido.',
    explanation: 'O código de recuperação fornecido é inválido.',
    localizations: {},
  },
  RecoveryCodeInvalidToken: {
    code: 'recovery-code/invalid-token',
    message: 'Token de recuperação inválido.',
    explanation: 'O token de recuperação fornecido é inválido.',
    localizations: {},
  },
  RecoveryCodeUserNotFound: {
    code: 'recovery-code/user-not-found',
    message: 'Usuário não encontrado.',
    explanation: 'O usuário associado a este código de recuperação não foi encontrado.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'recovery-code'>;

export const SignInErrorCodes = {
  SignInBradescoAccountNotFound: {
    code: 'sign-in/bradesco-account-not-found',
    message: 'Conta Bradesco não encontrada.',
    explanation: 'A conta Bradesco que você está tentando usar para entrar não foi encontrada.',
    localizations: {},
    ignored: true,
  },
  SignInInvalidBradescoToken: {
    code: 'sign-in/invalid-bradesco-token',
    message: 'Autenticação via Bradesco inválida. Verifique suas informações e tente novamente.',
    explanation: 'O token de autenticação do Bradesco fornecido é inválido.',
    localizations: {},
    ignored: true,
  },
  SignInInvalidGoogleToken: {
    code: 'sign-in/invalid-google-token',
    message: 'Autenticação via Google inválida.',
    explanation: 'O token de autenticação do Google fornecido é inválido. Tente entrar novamente.',
    localizations: {},
  },
  SignInMethodNotImplemented: {
    code: 'sign-in/method-not-implemented',
    message: 'Este método de login ainda não foi implementado.',
    explanation: 'O método de login que você está tentando usar ainda não foi implementado.',
    localizations: {},
  },
  SignInNotFound: {
    code: 'sign-in/not-found',
    message: 'Usuário não encontrado.',
    explanation: 'O usuário que você está tentando usar para entrar não foi encontrado.',
    localizations: {},
  },
  SignInUserNotFound: {
    code: 'sign-in/user-not-found',
    message: 'Usuário não encontrado.',
    explanation: 'O usuário que você está tentando usar para entrar não foi encontrado.',
    localizations: {},
  },
  SignInUserUnauthorized: {
    code: 'sign-in/user-unauthorized',
    message: 'Não foi possível fazer login. Verifique suas informações e tente novamente.',
    explanation:
      'O usuário não está autorizado a entrar. Pode estar desativado, sem permissão para acessar o sistema ou a senha estar incorreta.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'sign-in'>;
